import styled from "styled-components";
import { Slider, Typography } from "@mui/material";

// Styled Components
export const Container = styled.div`
  width: 100%;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSlider = styled(Slider)`
  color: rgba(143, 56, 239, 1) !important; /* Purple for selected track */
  height: 8px; /* Adjust thickness of the slider line */

  & .MuiSlider-track {
    background-color: rgba(143, 56, 239, 1); /* Purple for the selected portion */
    height: 8px; /* Adjust thickness for the selected line */
  }

  & .MuiSlider-rail {
    background-color: #d3b7e5; /* Light purple for the unselected portion */
    height: 8px; /* Adjust thickness for the unselected line */
  }

  & .MuiSlider-mark {
    height: 4px; /* Adjust dot height */
    width: 4px;  /* Adjust dot width */
    border-radius: 50%; /* Make the marks circular */
    background-color: rgba(143, 56, 239, 1); /* Purple for the marks */
  }

  & .MuiSlider-thumb {
    width: 14px;
    height: 14px;
    background-color: rgba(143, 56, 239, 1);

    &:hover {
      box-shadow: 0 0 0 8px rgba(106, 13, 173, 0.16); /* Subtle purple hover effect */
    }
  }
`;

// New Component for Selected Value
export const SelectedValue = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #6a0dad; /* Purple text */
  background-color: #f0e6fa; /* Light purple background */
  border-radius: 12px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
